export enum FeatureToggle {
  retailerCollections = 'rt_retailer_collections',
  retailerCollectionsV2 = 'rt_retailer_collections_ux_v2',
  storefront = 'rt_storefront',
  dynamicRulesProductInclusionExclusion = 'rt_dynamic_rules_product_inclusion_exclusion',
  dynamicCollectionPinProducts = 'rt_dynamic_collection_pin_products',
  flyersTermsApprovalRequired = 'rt_flyers_terms_approval_required',
  flyersValidationProgress = 'rt_flyers_validation_progress',
  flyersImageAltText = 'rt_flyers_image_alt_text',
  flyerCopyFlyerClickableAreasEnabled = 'rt_flyer_copy_flyer_clickable_areas_enabled',
  flyerCreateFlyerEnabled = 'rt_flyer_create_flyer_enabled',
  lowerPriceDefinitions = 'rt_lower_price_definitions',
  adminRetailerCollections = 'rt_admin_retailer_collections',
  retailerCreateDigitalFlyerEnabled = 'rt_warehouse_create_digital_flyer',
  aiCarouselCreatorM2 = 'rt_ai_carousel_creator_m2',
}
